import { render, staticRenderFns } from "./PopularBrands.vue?vue&type=template&id=8b6ccb2a"
import script from "./PopularBrands.vue?vue&type=script&lang=js"
export * from "./PopularBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports